// export const REACT_APP_API_KEY = 'http://192.168.1.7:5050/api/v1';
export const REACT_APP_API_KEY = process.env.REACT_APP_API_URL;
// export const REACT_APP_API_KEY = 'http://192.168.1.7:5050/api/v1';
// REACT_APP_API_URL=http://192.168.1.7:5050/api/v1
